export enum TagTestIds {
	TagLabelElementTestId = 'sl-tag-label',
	TagIconElementTestId = 'sl-tag-icon',
}
